import { useTheme } from "@mui/material/styles";

export const BgColor = {
  mainBg: "#FCFCFC",
  main: "#303537",
};

export const TxtColor = {
  txtMain: BgColor.main,
  txtSecond: "#313537",
  txtThird: "#BEBEBE",
  txtWhite: "#fff",
};

export const BtnColor = {
  btnMainBg: BgColor.main,
  btnMainText: "#fff",
};

export const SystemColor = {
  main: "#303537",
  gray: "#BEBEBE",
  success: "#044126",
  error: "#a40e1c",
  warning: "#ED6C02",
  info: "#0288D1",
  star: "#FFBD00",
};

export const shadowColor ="rgb(0 0 0 / 18%) 0px 6px 12px 0px"